import { render, staticRenderFns } from "./StakingLogs.vue?vue&type=template&id=4abec44a&scoped=true&"
import script from "./StakingLogs.vue?vue&type=script&lang=js&"
export * from "./StakingLogs.vue?vue&type=script&lang=js&"
import style0 from "./StakingLogs.vue?vue&type=style&index=0&id=4abec44a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abec44a",
  null
  
)

export default component.exports